/**
 * Transient, imperative cross-component signals for the ride edit drawer.
 *
 * These intentionally live outside Recoil/React state: the ride save flow spans
 * a component unmount (closing during save navigates the add route back to the
 * grid, unmounting the footer hook that runs the save). A plain module ref is
 * read/written synchronously and is unaffected by React render/commit timing or
 * component lifecycle, so the save handler can reliably observe a close that was
 * requested mid-save and skip reopening the edit drawer for the saved ride.
 */
export const rideDrawerSignals = {
  /** Set when the user closes the drawer while a ride save is in flight. */
  isCloseRequestedDuringSave: false,
  /**
   * Mirrors `rideSaveInProgressAtom` for synchronous reads from close handlers
   * that must not rely on a stale React render closure.
   */
  isSaveInProgress: false,
  /**
   * Set on mid-save close so the unsaved-changes prompt stays suppressed after
   * save's `finally` clears `isSaveInProgress` but before the drawer unmounts.
   * Cleared only on drawer unmount (not in form-atom cleanup, which runs earlier).
   */
  suppressUnsavedPromptUntilUnmount: false,
};
